import axios from 'axios';
import { mapCampaignJsonToXml } from '../../utils/cell/automation-mapper-utils';
import { deepCopyHandler } from '../../utils/konva-copy-utils';
import { sanitizeCellValue } from '../../utils/sanitization-utils';
/*
*  This file contains all axios calls related make copy operations
*/

export const makeCopy = async (funnelId, funnelCopyName, draftJson) => {
    const updatedCellJson = await Promise.all(draftJson.cells.map(async (cell) => {
        const deepCopyValue = await deepCopyHandler(cell, funnelId);

        if (!Object.keys(deepCopyValue).length) return cell;

        return { ...cell, value: { ...cell.value, ...deepCopyValue } };
    }));

    const sanitizedCells = updatedCellJson.map((cell) => {
        return sanitizeCellValue(cell, updatedCellJson);
    });

    const xml = mapCampaignJsonToXml({ cells: sanitizedCells });

    return axios.post('/app/funnel/copy', { xml, name: funnelCopyName, copyFromId: funnelId });
};
